module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CU-6815189936623da71b595cbe03735ecc.png";